/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createPaymentProfileFromDiscriminatorValue, type ErrorResponse, type InternalErrorResponse, type PaymentProfile } from '../../../../models/index.js';
// @ts-ignore
import { type WithPaymentProfileItemRequestBuilder, WithPaymentProfileItemRequestBuilderRequestsMetadata } from './item/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/payments/{customerNumber}/profiles
 */
export interface ProfilesRequestBuilder extends BaseRequestBuilder<ProfilesRequestBuilder> {
    /**
     * Gets an item from the MomentumAPI.api.payments.item.profiles.item collection
     * @param paymentProfileId Unique identifier of the item
     * @returns {WithPaymentProfileItemRequestBuilder}
     */
     byPaymentProfileId(paymentProfileId: string) : WithPaymentProfileItemRequestBuilder;
    /**
     * Get all payment profiles for a specific customer
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<PaymentProfile[]>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {ErrorResponse} error when the service returns a 404 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<ProfilesRequestBuilderGetQueryParameters> | undefined) : Promise<PaymentProfile[] | undefined>;
    /**
     * Get all payment profiles for a specific customer
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<ProfilesRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
/**
 * Get all payment profiles for a specific customer
 */
export interface ProfilesRequestBuilderGetQueryParameters {
    /**
     * Optional: OrganizationId to switch to (must be in user's OrgCodes)
     */
    useOrganizationId?: string;
}
/**
 * Uri template for the request builder.
 */
export const ProfilesRequestBuilderUriTemplate = "{+baseurl}/api/payments/{customerNumber}/profiles{?useOrganizationId*}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const ProfilesRequestBuilderNavigationMetadata: Record<Exclude<keyof ProfilesRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byPaymentProfileId: {
        requestsMetadata: WithPaymentProfileItemRequestBuilderRequestsMetadata,
        pathParametersMappings: ["paymentProfileId"],
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const ProfilesRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: ProfilesRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendCollection",
        responseBodyFactory:  createPaymentProfileFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
